import {BaseSearchableService} from "./Core/BaseSearchableService";

class UserService extends BaseSearchableService {
    get Url() { return super.Url + "/users"; }
    get ModelName() { return "User"; }
    get PrimaryKeyProperty() { return "userId"; }

    Get(modelId, useCache) {
        return this.SendRequest(BaseSearchableService.GET);
    }

    UpdateUser(user) {
        return this.SendRequest(BaseSearchableService.PUT, user);
    }

    CreateUser(user) {
        return this.SendRequest(BaseSearchableService.POST, user);
    }

    DeleteUser(userId) {
        return this.SendRequest(BaseSearchableService.DELETE, userId);
    }
}

export const service = new UserService();

